import { useEffect } from 'react';
import { useAuth } from './useAuth';
import { CAPABILITIES, getEffectiveCapabilities } from '../helpers/capabilities';
import { useGetMe } from '@openapi/auth/auth';

export function useCapabilities() {
    const { user, setUser, logoutUser } = useAuth();

    const { data, isLoading, error } = useGetMe({
        query: {
            enabled: !!user,
        },
    });

    useEffect(() => {
        if (error?.response?.status === 401) {
            logoutUser();
        }
    }, [error, logoutUser]);

    useEffect(() => {
        if (data) {
            setUser((prev) => (prev ? { ...prev, ...data } : prev));
        }
    }, [data, setUser]);

    const can = (caps) => {
        if (!user) return false;
        if (user.isSuperAdmin) return true;
        const effective = getEffectiveCapabilities(user.capabilities || []);
        const list = Array.isArray(caps) ? caps : [caps];
        return list.some((c) => effective.has(c));
    };

    const loading = !!user && !user.isSuperAdmin && !Array.isArray(user.capabilities) && isLoading;

    return { can, loading, CAPABILITIES };
}
